import { render, staticRenderFns } from "./TearsheetModal.vue?vue&type=template&id=b3c04648&scoped=true&"
import script from "./TearsheetModal.vue?vue&type=script&lang=js&"
export * from "./TearsheetModal.vue?vue&type=script&lang=js&"
import style0 from "./TearsheetModal.vue?vue&type=style&index=0&id=b3c04648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c04648",
  null
  
)

export default component.exports